module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxjaXJjbGUgZmlsbD0iI0ZGRiIgY3g9IjciIGN5PSIyMCIgcj0iMyIvPjxwYXRoIGQ9Ik0xMCAyMGg0bTEtMTN2MjZtOC0yNnYyNm01LTIxdjE2bTQtMTJ2OG00LTV2M20tOS0yaC00Ii8+PC9nPjwvZz48L3N2Zz4=\""


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./images/repairs/overcurrent.svg
 ** module id = 3590
 ** module chunks = 3
 **/